"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType["Evergreen"] = "Evergreen";
    TransactionType["Term"] = "Term";
    TransactionType["TermAutoRenew"] = "Term - Auto Renew";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
//# sourceMappingURL=provisioningOrder.js.map